<template>
  <a href="#" class="back-to-top-button opacity-0" @click="scrollToTop">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      class="w-6 h-6"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M4.5 10.5L12 3m0 0l7.5 7.5M12 3v18"
      />
    </svg>
  </a>
</template>
  
<script setup>
import { onMounted } from 'vue';

const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

onMounted(() => {
  const backToTopButton = document.querySelector(".back-to-top-button");
  const scrollContainer = () => {
    return document.documentElement || document.body;
  };
  const scrollHeight = window.innerHeight / 2;

  document.addEventListener("scroll", () => {
    if (scrollContainer().scrollTop > scrollHeight) {
      backToTopButton.classList.remove("opacity-0");
    } else {
      backToTopButton.classList.add("opacity-0");
    }
  });
});
</script>

  <style scoped>
.back-to-top-button {
  background-color: #00810e;
  color: #fff;
  font-weight: 600;
  border-radius: 100px;
  text-align: center;
  padding: 10px;
  line-height: 20px;
  text-transform: capitalize;
  opacity: 0.6;
  transition: all 0.15s ease-in-out;
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 10;
}

.back-to-top-button.opacity-0 {
  opacity: 0;
}

.back-to-top-button:hover {
  opacity: 1;
}
</style>
  